/**
 * Counter State - Default Implementation
 *
 * Provides the default implementation of ICounterState.
 * SPAs can use this directly or create custom implementations.
 */

import { Signal } from "@lit-labs/signals";
import type { ICounterState } from "./types";

/**
 * Default counter state implementation using Signal.State.
 * Properties are reactive - components using SignalWatcher auto-update.
 */
export class CounterState implements ICounterState {
  readonly count = new Signal.State(0);
  readonly lastUpdated = new Signal.State<Date | null>(null);
}
